import { useEffect } from "react";

// Matches the <title> in index.html.
const DEFAULT_TITLE = "Eventera";

/**
 * Set `document.title` for as long as the calling component is mounted.
 *
 * Pass the page's own name — a collection title, a person's name — or a falsy
 * value to fall back to the app name. On unmount the title is restored to the
 * default, so a route that sets no title of its own (a record permalink, the
 * admin page) does not inherit a stale one from the view that preceded it.
 */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
